module.exports = __webpack_public_path__ + "img/reddit.e23e414e.svg";